export const publicationsData = [
  {
    id: 1,
    title:
      "A Hybrid Robust Watermarking System based on Discrete Cosine Transform, Discrete Wavelet Transform, and Singular Value Decomposition",
    description: [
      { id: 1, text: <strong>Mahbuba Begum</strong> },
      {
        id: 2,
        text: ', Jannatul Ferdush, Mohammad Shorif Uddin, "A Hybrid Robust Watermarking System based on Discrete Cosine Transform, Discrete Wavelet Transform, and Singular Value Decomposition," Journal of King Saud University-Computer and Information Sciences, Elsevier, 2021. ',
      },
      { id: 3, text: <strong>(SCIE and Scopus Indexed)</strong> },
    ],
    link: "https://www.sciencedirect.com/science/article/pii/S1319157821001798",
  },
  {
    id: 2,
    title:
      "Analysis of the performance of feature optimization techniques for the diagnosis of machine learning-based chronic kidney disease",
    description: [
      {
        id: 4,
        text: "Muhammad Minoar Hossain, Reshma Ahmed Swarna, Rafid Mostafiz, Pabon Shaha, Lubna Yasmin Pinky, ",
      },
      { id: 5, text: <strong>Mohammad Motiur Rahman</strong> },
      {
        id: 6,
        text: ", Wahidur Rahman, Md. Selim Hossain, Md. Elias Hossain, Md. Sadiq Iqbal, ",
      },
      {
        id: 7,
        text: (
          <strong>Machine Learning with Applications (2022), Elsevier.</strong>
        ),
      },
    ],
    link: "https://www.sciencedirect.com/science/article/pii/S2666827022000421",
  },
  {
    id: 3,
    title:
      "Automatic malaria disease detection from blood cell images using the variational quantum circuit",
    description: [
      {
        id: 8,
        text: "Muhammad Minoar Hossain, Md Abdur Rahim, Ali Newaz Bahar, ",
      },
      {
        id: 9,
        text: (
          <strong>
            Mohammad Motiur Rahman, Informatics in Medicine Unlocked{" "}
          </strong>
        ),
      },
      {
        id: 10,
        text: "26 (2021) 100743, ",
      },
      {
        id: 11,
        text: <strong>Elsevier</strong>,
      },
    ],
    link: "https://www.sciencedirect.com/science/article/pii/S2352914821002197?via%3Dihub",
  },
];
